import { z } from 'zod';
/**
 * Enum for position scope types
 */
export const PositionScope = {
    Government: 'government',
    Department: 'department',
};
const positionBaseSchema = z.object({
    title: z
        .string('Title is required')
        .min(1, 'Title is required')
        .max(300, 'Title must be less than 300 characters'),
    description: z.string().nullish(),
    scope: z.enum(PositionScope, 'Scope is required'),
});
/**
 * Schema for creating a new position
 */
export const positionCreateSchema = positionBaseSchema
    .extend({
    userId: z.number().nullish(),
    backupUserId: z.number().nullish(),
})
    .refine((data) => {
    // userId and backupUserId are only allowed for government-scoped positions
    if (data.scope === PositionScope.Department) {
        return data.userId === null || data.userId === undefined;
    }
    return true;
}, {
    message: 'User assignments are only allowed for government-scoped positions',
    path: ['userId'],
})
    .refine((data) => {
    // userId and backupUserId are only allowed for government-scoped positions
    if (data.scope === PositionScope.Department) {
        return data.backupUserId === null || data.backupUserId === undefined;
    }
    return true;
}, {
    message: 'User assignments are only allowed for government-scoped positions',
    path: ['backupUserId'],
});
/**
 * Schema for updating an existing position
 */
export const positionUpdateSchema = positionBaseSchema.partial().omit({ scope: true });
/**
 * Schema for a single position assignment
 */
export const positionAssignmentSchema = z.object({
    departmentId: z.number().nullish(),
    userId: z.number().nullish(),
    backupUserId: z.number().nullish(),
});
/**
 * Schema for updating position assignments (supports batch updates)
 */
export const positionAssignmentsUpdateSchema = z.object({
    assignments: z.array(positionAssignmentSchema),
});
